import constants from '../services/constants';
import { atom } from 'recoil';

const scrollCommentIntoViewAtom = atom<boolean>({
    key: constants.scrollCommentIntoViewAtom,
    default: false,
});

export default scrollCommentIntoViewAtom;